import { render, staticRenderFns } from "./SelectResource.vue?vue&type=template&id=db23d79c&"
import script from "./SelectResource.vue?vue&type=script&lang=js&"
export * from "./SelectResource.vue?vue&type=script&lang=js&"
import style0 from "./SelectResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports